import * as React from "react";
import update = require("react-addons-update");

export interface DropDownProps
{
	fieldName: string;
	label: string;
	placeholder?: string;
	tooltip?: string;
	items: Array<any>;
	itemValue?: string;
	itemDisplayName?: string;
	arrayIsSingleValue: boolean;
	onChange?: (event: React.FormEvent<any>) => void;
	value?: string;
	pleaseSelectLabel?: string;
	isRequired?: boolean;
	requiredMessage?: string;
}

export interface DropDownState
{
	value?: string;
}

export class DropDown extends React.Component<DropDownProps, DropDownState>
{
	state: DropDownState = {};

	componentDidMount()
	{
		this.setState(update(this.state, { $set: { value: this.props.value } }));
	}

	componentWillReceiveProps(nextProps: DropDownProps)
	{
		if (nextProps.value !== this.state.value)
			this.setState(update(this.state, { $set: { value: nextProps.value } }));
	}

	render()
	{
		const selectItems = this.generateSelectItems();
		return <div className="form-group" title={this.props.tooltip}>
			       <label>{this.props.label}</label>
			       <select onChange={this.handleChange.bind(this)} className="form-control" name={this.props
				       .fieldName} value={this.state.value}>
				       {selectItems}
			       </select>
			       {this.getRequiredMessage() }
		       </div>;
	}

	private getRequiredMessage()
	{
		if (!this.props.isRequired)
		{
			return null;
		}
		if (this.state.value === null || this.state.value === undefined)
		{
			return this.getRequiredMessageInternal();
		}
		if (this.state.value !== null && this.state.value !== undefined)
		{
			if (this.state.value.trim().length === 0)
			{
				return this.getRequiredMessageInternal();
			}
		}
		return null;
	}

	private getRequiredMessageInternal()
	{
		return <span className="text-danger bg-danger">{this.props.requiredMessage || "Required"}</span>;
	}

	private generateSelectItems()
	{
		let i = 0;
		const dataProps = this.props.items;
		if (!dataProps)
		{
			return null;
		}
		const len = dataProps.length;
		const items: Array<JSX.Element> = [];

		if (this.props.pleaseSelectLabel)
		{
			var emptyValue = "";
			items.push(<option value={emptyValue} key="pleaseSelect">{this.props.pleaseSelectLabel}</option>);
		}

		for (i; i < len; i++)
		{
			let arrayIsSimple = this.props.arrayIsSingleValue;
			const dataProp = dataProps[i];
			const item = <option key={arrayIsSimple ? dataProp : dataProp[this.props.itemValue]}
				value={arrayIsSimple ? dataProp : dataProp[this.props.itemValue]}>{arrayIsSimple ? dataProp : dataProp[this.props.itemDisplayName]}</option>;
			items.push(item);
		}
		return items;
	}

	private handleChange(ev: React.FormEvent<any>)
	{
		var value = ev.target.value;
		this.setState(update(this.state, { $set: { value: value } }));

		if (this.props.onChange)
		{
			this.props.onChange(ev);
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/common/DropDown.tsx